import React, { Suspense } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Layout, Typography, theme } from 'antd';
import { MapRoutes, authRoutes, MapRoutesProps } from '../../router';
import { Loading } from '../../components';
import './styles.scoped.css';

const { useToken } = theme;

const getRouteComponent: MapRoutesProps['render'] = ({ route }) => {
  const { component: Component } = route;
  // @ts-ignore
  return <Component route={route} />;
};

function Auth() {
  const { token } = useToken();
  return (
    <Layout>
      <Layout
        className="main"
        style={{ height: '100vh', overflow: 'auto', scrollBehavior: 'smooth' }}
      >
        <Layout.Header
          className="navbar"
          style={{
            backgroundColor: token.colorBgContainer,
            boxShadow: token.boxShadow,
            justifyContent: 'center',
          }}
        >
          <Link to="/" className="logo-link">
            <Typography.Title level={2} style={{ color: token.colorPrimaryActive }}>
              <img src="./LOGO_RADIAN.svg" alt="Radian" height={50} />
            </Typography.Title>
          </Link>
        </Layout.Header>

        <Suspense fallback={<Loading size="large" />}>
          <MapRoutes
            routes={authRoutes}
            render={getRouteComponent}
            default={() => <Navigate replace to="/login" />}
          />
        </Suspense>
      </Layout>
    </Layout>
  );
}

export default Auth;
